import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useFormikWithoutDirtyForm } from "../../../../../../../forms/useFormikWithDirtyForm";
import { DependantFormValue, createEmptyDependant } from "../../../RelativesView.types";
import { createDependantSchema } from "../../../RelativesView.validation";

export function useAddDependant(onAdd: (dependant: DependantFormValue) => void, onClose: () => void) {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => createDependantSchema(t), [t]);

  const formik = useFormikWithoutDirtyForm<DependantFormValue>({
    initialValues: createEmptyDependant(crypto.randomUUID()),
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: (values) => {
      onAdd(values);
      onClose();
    },
  });

  return { formik };
}
